import { stringify } from 'query-string';

import { camelToSnake } from './camelToSnake';

import { ICGIUrlOptions, IParams, IUser } from '@interfaces';

interface ICgiGet {
	url: string;
	args?: ICGIUrlOptions;
	params?: IParams;
	user?: Pick<IUser, 'id' | 'email' | 'magicNumber'>;
}

const getPrefixedArgs = (args: ICGIUrlOptions) => {
	const argsArr = Object.keys(args)
		.sort((a: string, b: string) => {
			if (a === b) {
				return 0;
			}

			return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
		})
		.map((key: string ) => {
			if (key in args && args[key]) {
				return `arg_${camelToSnake(key)}=${args[key]}`;
			}
		})
		.filter((query: string) => query !== undefined);

	return argsArr.join('&');
};

const getUserParams = (user: Pick<IUser, 'email' | 'magicNumber'>) => (stringify({
	xemail: user?.email || undefined,
	mna: user?.magicNumber?.a || undefined,
	mnb: user?.magicNumber?.b || undefined,
}));

export const getCgiUrl = (options: ICgiGet) => [
	`${options.url}?ajax_call=1`,
	options.user?.id ? `${getUserParams(options.user)}` : null,
	options.params ? `${stringify(options.params)}` : null,
	options.args ? `${getPrefixedArgs(options.args)}` : null,
]
	.filter((query: string) => query && query.length)
	.join('&');
